// extracted by mini-css-extract-plugin
export default {"employee-header":"Header_employee-header__RPlyr","employee-header__buttons":"Header_employee-header__buttons__uB9Hn","employee-header-item":"Header_employee-header-item__0JgwR"};